import Vue from 'vue'
import Select2 from 'v-select2-component'
import DateRangePicker from 'vue2-daterange-picker'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Select2MultipleControl from 'v-select2-multiple-component'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Default from '../layout/Wrappers/defaultLayout.vue'
import Login from '../layout/Wrappers/loginLayout.vue'
import { BootstrapVue } from 'bootstrap-vue'
import VueLoadingOverlay from 'vue-loading-overlay'
import Multiselect from 'vue-multiselect'
import DraggableTable from '@/components/draggable-table'
import Status from '@/components/common/Status'
import VCalendar from 'v-calendar';
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VCalendar)


Vue.component('DraggableTable', DraggableTable)
Vue.component('Status', Status)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('Select2', Select2)
Vue.component('DateRanger', DateRangePicker)
Vue.component('Datepicker', Datepicker)
Vue.component('Select2MultipleControl', Select2MultipleControl)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('DateRangePicker', DateRangePicker)
Vue.component('VueLoadingOverlay', VueLoadingOverlay)
Vue.component('default-layout', Default)
Vue.component('login-layout', Login)
Vue.component('multiselect', Multiselect)
